import { Injectable } from '@angular/core';
import { SingletonServiceGuard } from '@lsq-frontend/angular-shared/features/generic-get-services';
import { Observable, Subject } from 'rxjs';

/**
 * Add a new customer data
 */
@Injectable({ providedIn: 'root' })
export class AdvancedSearchService {
    public searchSubject: Subject<object> = new Subject();
    public searchStream: Observable<object>;

    constructor() {
        SingletonServiceGuard.register('AdvancedSearchService');
        this.searchStream = this.searchSubject.asObservable();
    }

    public search(customer: object): void {
        this.searchSubject.next(customer);
    }
}
